import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon1: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 19.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 19" width={width} height={height} {...props}>
      <Path
        d="M14.3345 8.703C14.305 8.019 14.1132 7.33901 13.7581 6.72501L10.6263 1.31C10.3869 0.895998 10.2224 0.453 10.1316 0L10.0011 0.22699C9.225 1.56699 9.225 3.21801 10 4.55801L12.5054 8.89099C13.2804 10.231 13.2804 11.883 12.5054 13.224L12.3738 13.449C12.2819 12.996 12.1185 12.553 11.879 12.141L9.5847 8.17401L8.121 5.64099C7.88154 5.22899 7.71814 4.78601 7.62623 4.33301L7.49574 4.55801C6.72302 5.89401 6.72075 7.53901 7.4878 8.87701L10.0011 13.224C10.775 14.564 10.775 16.216 10.0011 17.557L9.8684 17.783C9.7776 17.329 9.6131 16.886 9.3737 16.473L6.24192 11.057C5.82322 10.331 5.63032 9.513 5.66549 8.703C2.31363 9.578 0 11.435 0 13.585C0 16.575 4.47634 19 10.0011 19C15.5237 19 20 16.575 20 13.585C20 11.435 17.6864 9.576 14.3345 8.703Z"
        fill="#F3123C"
      />
    </Icon>
  )
}
